import styled from 'styled-components'

export const StyledCommissionTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
